import React from "react";
import { useEffect, useState, useRef } from "react";
import NavButton from "../../homepage/header-banner/TopNavButton";
import MongoDB from "../../homepage/header-banner/MongoDB";
import Footer from "../../homepage/footer/Footer";
import Cloudconsult from "../../homepage/consult/cloudconsult";
import CloudconsultCp from "../../homepage/consult/cloudconsult-cp";
import Banner from "../../container/Banner/Banner";
import { Container, Row, Col } from "react-bootstrap";
import Sidebar from "../../container/Sidebar/Sidebar";
import "../../container/Sidebar/sidebar.css";
import Titlecloudcompute from "../../container/Card/Components/Titlecloudcompute";
import Contentcloudcard from "../../container/Card/Components/Contentcloudcard";
import Imagecloudcompute from "../../container/Card/Components/Imagecloudcompute";
// import { MuiGrid } from '@mui/material';
import CardBox from "../../container/Box/Components/CardBox";
import "../../Style/typo.css";
import Cloudconsult2 from "../../homepage/consult/cloudconsult-2";
import BannerPrivateCloud from "../../container/Banner/banner-privateCloud";
import DividerComponent from "../../container/Divider/divider";
import styled from "styled-components";
import useIsMobile from "../../container/Sidebar/useIsMobile";
import BannerPrivateCloudVN from "../../container/Banner/banner-privateCloud-vn";
import Cloudconsult2VN from "../../homepage/consult/cloudconsult-2-vn";
import SidebarVN from "../../container/Sidebar/Sidebar-vn";
import HeaderVn from "../../detailpageVN/Page/component/headervn";
import FooterVn from "../../detailpageVN/Page/component/footervn";

const Sysfont = styled.div`
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif;
`;

function ClustercloudmongodbVN() {
    const isMobile = useIsMobile();
    useEffect(() => {
        document.title = "Private MongoDB Cluster - Private Kubernetes - Private Cloud";
    }, []);
    return (
        <Sysfont className="App">
            <HeaderVn />
            <BannerPrivateCloudVN />
            <Container className="main-body">
                <Row>
                    <Col md={12} lg={3}>
                        {!isMobile && <SidebarVN />}
                    </Col>
                    <Col md={12} lg={9} className="right-content">
                        {/* {Titlecloudcompute("Kubernetes for MongoDB")} */}
                        {/* {Contentcloudcard("모든 컨테이너(POD) 고용량 SSD 디스크 제공, 고용량의 메모리 할당")} */}
                        <MuiGrid container spacing={3}>
                            <MuiGrid item xs={12} sm={12}>
                                {CardBox(
                                    "<p class='typo-21-sm typo-medium typo-black'>Động cơ cơ sở dữ liệu NoSQL hỗ trợ Replica dựa trên cluster Kubernetes.</p>",
                                    `<p class='typo-14'>Hệ thống hỗ trợ phân mảnh (sharding) để phân phối dữ liệu trong nhóm Replica Set.</p>
                                <p class='typo-14'>Dễ dàng vận hành và quản lý, phù hợp với các dịch vụ yêu cầu xử lý khối lượng dữ liệu lớn.</p>
                                <p class='typo-14'>Cung cấp hiệu suất vượt trội so với các hệ quản trị cơ sở dữ liệu RDBMS truyền thống.</p>`,
                                )}
                            </MuiGrid>
                            <DividerComponent />
                            <MuiGrid item xs={12} sm={12}>
                                {CardBox(
                                    "<p class='typo-21-sm typo-medium typo-black'>Vận hành Persistent Volume với hiệu suất cao, tối ưu hóa hiệu suất I/O.</p>",
                                    `<p class='typo-14'>Hệ thống sử dụng Persistent Volume (PV) SSD, với 3 container replica (POD) tạo thành một đơn vị dịch vụ.</p>
                                <p class='typo-14'>Ngay cả khi phần cứng của một worker node trong Kubernetes gặp sự cố, dịch vụ vẫn tiếp tục hoạt động trên các container (POD) của những worker node khác mà không bị gián đoạn.</p>`,
                                )}
                            </MuiGrid>
                            <DividerComponent />
                            <MuiGrid item xs={12} sm={12}>
                                {CardBox(
                                    "<p class='typo-21-sm typo-medium typo-black'>Hệ thống tự động di chuyển container (POD) khi có sự cố phần cứng, đảm bảo hoạt động liên tục và không gián đoạn.</p>",
                                    `<p class='typo-14'>Các container (POD) của Kubernetes MongoDB bao gồm 3 node replica cho mỗi dịch vụ đơn vị.</p> 
                                <p class='typo-14'>Các replica container (POD) được phân bố trên nhiều worker node trong Kubernetes, giúp tăng tính sẵn sàng và khả năng chịu lỗi của hệ thống.</p>`,
                                )}
                            </MuiGrid>
                            <DividerComponent />
                            <MuiGrid item xs={12} sm={12}>
                                {CardBox(
                                    "<p class='typo-21-sm typo-medium typo-black'>Hệ thống tự động mở rộng quy mô (autoscaling), giúp mở rộng container và phân phối tải dịch vụ một cách linh hoạt.</p>",
                                    `<p class='typo-14'>Số lượng container (POD) được điều chỉnh định kỳ dựa trên các chỉ số như CPU, bộ nhớ hoặc các metric tùy chỉnh.</p>
                                <p class='typo-14'>Không cần chuẩn bị tài nguyên phần cứng riêng biệt cho việc mở rộng dịch vụ.</p>
                                <p class='typo-14'>Đây là giải pháp cluster hiệu quả trong việc phân phối tải và tối ưu chi phí dịch vụ.</p>`,
                                )}
                            </MuiGrid>
                            <DividerComponent />
                            <MuiGrid item xs={12}>
                                {Imagecloudcompute("https://hanbiro.com/cloud/library/cluster-cloud-mongodb/mongodb_cluster.svg")}
                            </MuiGrid>
                            <DividerComponent />
                        </MuiGrid>
                        {/* <MongoDB /> */}
                        <Cloudconsult2VN />
                    </Col>
                </Row>
            </Container>

            <FooterVn />
        </Sysfont>
    );
}

const MuiGrid = styled.div`
    padding: 0px;
`;

export default ClustercloudmongodbVN;
